import React from 'react';
import { ToggleButton, ToggleButtonItem } from '@apply/components';
import { ButtonGroupTypes } from 'devextreme-react/button-group';
import { OwnerType } from '../types';

interface OwnerTypeTabsProps {
    id: string;
    value: OwnerType;
    onChange: (ownerType: OwnerType) => void;
    disabled?: boolean;
}

const ITEMS: ToggleButtonItem[] = [
    { id: String(OwnerType.Person), text: 'Person', hint: 'An individual person' },
    { id: String(OwnerType.PeopleGroup), text: 'Group of People', hint: 'A group of people' },
    { id: String(OwnerType.Entity), text: 'Entity', hint: 'Another legal entity' },
];

export const OwnerTypeTabs: React.FC<OwnerTypeTabsProps> = ({ id, value, onChange, disabled = false }) => (
    <ToggleButton
        id={id}
        items={ITEMS.map((item) => ({ ...item, disabled }))}
        selectedItems={[String(value)]}
        selectionMode='single'
        stylingMode='outlined'
        onItemClick={(e: ButtonGroupTypes.ItemClickEvent) => {
            const next = Number((e.itemData as ToggleButtonItem)?.id) as OwnerType;
            if (next !== value) {
                onChange(next);
            }
        }}
        width='100%'
        height='40px'
    />
);
